import * as actionTypes from "../Actions/action-types";
const initialState = {
  ALL: [],
  Category: {},
  EachCat: [],
  vegMap: {},
  itemMap: {},
  cart: {},
  totalPrice: 0,
  error: false,
  isLoading: true,
  counter: 0,
  lastItemClicked: null,
  isSwitch: false,
  status: false,
  isVeg: false,
  cartDup: {}
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ITEMS:
      return {
        ...state,
        ALL: action.ALL,
        Category: action.Category,
        EachCat: action.EachCat,
        vegMap: action.vegMap,
        itemMap: action.itemMap,
        isLoading: false,
        cart: {},
        totalPrice: 0,
        counter: 0,
        isSwitch: false,
        lastItemClicked: null,
        status: true,
        error: false,
        isVeg: false,
        cartDup: {}
      };

    case actionTypes.FETCHED_ITEMS_FAILS:
      debugger;
      return {
        ...state,
        status: false,
        error: true,
        isLoading: false
      };

    case actionTypes.ADD_ITEM:
      // debugger;
      const k1 = state.counter + 1;
      let c = { ...state.cart };
      let currentItem = state.cart[action.itemId];
      if (currentItem) {
        let total = state.totalPrice + currentItem.customerPayable;

        c[action.itemId].quantity += 1;
        return {
          ...state,
          cart: c,
          counter: k1,
          totalPrice: total,
          lastItemClicked: action.itemId
        };
      } else {
        let ob = { ...state.itemMap[action.itemId], quantity: 0 };
        ob.quantity += 1;
        let total = state.totalPrice + ob.customerPayable;
        let yr = action.itemId;
        c[yr] = ob;
        return {
          ...state,
          cart: c,
          counter: k1,
          totalPrice: total,
          lastItemClicked: action.itemId
        };
      }

    case actionTypes.DELETE_ITEM:
      if (state.cart[action.itemId] !== undefined) {
        let c = { ...state.cart };
        let total = state.totalPrice - c[action.itemId].customerPayable;

        const k1 = state.counter - 1;
        if (c[action.itemId].quantity > 1) {
          c[action.itemId].quantity -= 1;

          return {
            ...state,
            cart: c,
            counter: k1,
            totalPrice: total,
            lastItemClicked: action.itemId
          };
        } else {
          c[action.itemId] = undefined;
          return {
            ...state,
            cart: c,
            counter: k1,
            totalPrice: total,
            lastItemClicked: action.itemId
          };
        }
      } else return state;

    case actionTypes.RESET:
      return {
        ALL: [],
        Category: {},
        EachCat: [],
        vegMap: {},
        itemMap: {},
        cart: {},
        totalPrice: 0,
        error: false,
        isLoading: true,
        counter: 0,
        lastItemClicked: null,
        isSwitch: false,
        status: false,
        isVeg: false,
        cartDup: {}
      };

    case actionTypes.CLEAR_CART:
      let b = {};
      return {
        ...state,
        cartDup: state.cart,
        cart: b,
        counter: 0,
        totalPrice: 0,
        lastItemClicked: null
      };
    case actionTypes.TOGGEL:
      if (state.isVeg === false) {
        return {
          ...state,
          isVeg: true,
          lastItemClicked: null,
          isSwitch: true,
          error: false
        };
      } else {
        return {
          ...state,
          isVeg: false,
          lastItemClicked: null,
          isSwitch: true,
          error: false
        };
      }
    case actionTypes.TOGGEL_LOADING:
      return {
        ...state,
        isLoading: action.payload
      };
    default:
      return state;
  }
};
export default reducer;
